import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import { createUseLocaleKeys } from 'anchor-i18n/react';
import { isNativePlatform } from '~/is-native';
import { DEFAULT_LOCALE, readLocaleCookie, SUPPORTED_LOCALES } from './locales';
const initialLanguage = readLocaleCookie(document.cookie);
export const buildLocaleLoadPath = (staticFilesPath)=>"".concat(staticFilesPath !== null && staticFilesPath !== void 0 ? staticFilesPath : '', "/locales/{{lng}}.json");
const initHttpI18n = (lng)=>i18next.use(HttpBackend).use(ICU).use(initReactI18next).init({
        lng,
        fallbackLng: DEFAULT_LOCALE,
        supportedLngs: [
            ...SUPPORTED_LOCALES
        ],
        backend: {
            loadPath: buildLocaleLoadPath(window._staticFilesPath)
        },
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: true
        }
    });
// WHY: i18next.init loads only the fallback bundle on native — reloadResources fetches the active language explicitly.
export const initNativeI18n = async (lng)=>{
    await initHttpI18n(lng);
    await i18next.reloadResources([
        lng
    ]);
    await i18next.changeLanguage(lng);
};
if (process.env.NODE_ENV === 'development') {
    // Development and test mode: Load the active language synchronously (no HTTP, no Suspense needed).
    // Always also load the fallback locale so missing keys fall back to English instead of
    // rendering the literal key path.
    const activeTranslations = require("anchor-i18n/dist/frontend/".concat(initialLanguage, ".json"));
    const resources = initialLanguage === DEFAULT_LOCALE ? {
        [DEFAULT_LOCALE]: {
            translation: activeTranslations
        }
    } : {
        [initialLanguage]: {
            translation: activeTranslations
        },
        [DEFAULT_LOCALE]: {
            translation: require("anchor-i18n/dist/frontend/".concat(DEFAULT_LOCALE, ".json"))
        }
    };
    i18next.use(ICU).use(initReactI18next).init({
        lng: initialLanguage,
        fallbackLng: DEFAULT_LOCALE,
        supportedLngs: [
            ...SUPPORTED_LOCALES
        ],
        resources,
        initImmediate: false,
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    });
} else if (!isNativePlatform()) {
    // WHY: native defers init to the bootstrap's initNativeI18n (Preferences-resolved locale; capacitor:// drops the cookie this reads).
    void initHttpI18n(initialLanguage);
}
export const useLocaleKeys = createUseLocaleKeys();
export default i18next;
